import {
  CampaignsStatisticsState,
  REQUEST_CAMPAIGNSTATISTICS,
  REQUEST_CAMPAIGNSTATISTICS_DONE
} from "./types";

const initialState: CampaignsStatisticsState = {
  isLoading: true,
  campaignStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_CAMPAIGNSTATISTICS:
      return {
        isLoading: true,
        campaignStatistics: action.payload
      };
    case REQUEST_CAMPAIGNSTATISTICS_DONE:
      return {
        isLoading: false,
        campaignStatistics: action.payload
      };
    default:
      return state;
  }
}
